import $ from 'jquery';
import { addToBagWithData } from '../../modules/add-to-bag';

function showSizeError() {
    $('#sizeError').fadeIn();
    $('#sizeErrorText').attr("role", "alert");
}

function hideFittingRoom() {
    $('input[name=tryon-size-options]').prop('checked', false);
    $("#accordionTryOnItem").hide();
}

function getFitItemSizes() {
    return $('input[name=tryon-size-options]:checked').val();
}

export const pdpAddToBag = ($el, opts) => {
    const code = opts.code ? opts.code : $('#code').val();
    const size = opts.size ? opts.size : $('#sizeValue').val();
    const isOOSSize = $('#sizeValue').data('oosSize');
    const assignedSellableDefectItemSerialNumber = $('#assignedSellableDefectItemSerialNumber').val();
    const isMens = $('#header-jsp').data('department') === 'Mens';

    if (size === null || size === '') {
        showSizeError();
        $('.size-options').focus();
    } else if(!isOOSSize) {
        if ($el) {
            $el.prop('disabled', true);
        }
        $(document).trigger('productAddedToBag');
        const fitItemsSelected = getFitItemSizes();
        if (fitItemsSelected && fitItemsSelected.trim().length) {
            hideFittingRoom();
        }
        let data = {
            productCode: code,
            size: size,
            sectionURL: window.rcProps.sectionUrl,
            sessionID: window.rcProps.sessionId,
            isMens: isMens,
            src: opts.src ? opts.src : 'addtobag',
            csrfHash: window.rcProps.csrfHash,
            useReferrer: true,
            isPopup: false,
            qvclick: window.rcProps.qvClick,
            hotlistQuickView: false,
            fitItemSizes: fitItemsSelected,
            serial: assignedSellableDefectItemSerialNumber,
            department: window.rcProps.pdp.department,
            cat1: window.rcProps.pdp.cat1
        };
        if ($el) {
            data.focusID = $el.attr('id');
        }
        if ($(".js-counter-value").length) {
            data.count = $(".js-counter-value").text();
        }
        if ($('#replenish-save').is(':checked')){
            data.subscriptionInterval = $('#subscription-interval option:selected').val();
        }

        addToBagWithData(data);
    } else {
        $('#sizeError').html(opts.oosText);
        $('#sizeError').css('display', 'block')
        $('#sizeError').delay(2000).fadeOut();
    }
}



// WEBPACK FOOTER //
// ./src/scripts/entry-points/pdp/add-to-bag-function.js